export default __webpack_public_path__ + "static/media/upload-icon.50febfd6.svg";